import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { useGlobal } from '@/utils/useGlobal';
import { Collapse } from 'antd';
import isEmpty from 'lodash/isEmpty';
import Empty from '../Empty';
import css from './index.module.scss';
const { Panel } = Collapse;
export default function Supports({ faqs, isMobile = false }: any) {
    const { useState, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [activeKey, setActiveKey] = useState(0);

    const onChange = (key) => {
        setActiveKey(key);
        const filterItem = faqs.find((v) => v.id === (key ? key : activeKey));
        if (filterItem) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_faq',
                title_name: filterItem.content?.title,
                status: key ? 'open' : 'close',
            });
        }
    };

    return (
        <>
            {!isEmpty(faqs) ? (
                <Collapse
                    accordion
                    bordered={false}
                    defaultActiveKey="2"
                    onChange={onChange}
                    expandIcon={({ isActive }) => (
                        <div
                            style={{
                                top: '20%',
                                transform: isMobile
                                    ? isActive
                                        ? 'rotate(-180deg)'
                                        : 'rotate(0deg)'
                                    : isActive
                                    ? 'rotate(0deg)'
                                    : locale === 'sa'
                                    ? 'rotate(90deg)'
                                    : 'rotate(-90deg)',
                                transition: 'all .3s',
                                lineHeight: 0,
                                right: 0,
                            }}
                        >
                            <EFArrowDown />
                        </div>
                    )}
                    expandIconPosition="right"
                    className={`${css.supports} site-collapse-custom-collapse`}
                >
                    {faqs.map((faq: any) => (
                        <Panel className="site-collapse-custom-panel" header={faq.content?.title} key={faq.id}>
                            <p className="text">{faq.content?.description}</p>
                        </Panel>
                    ))}
                </Collapse>
            ) : (
                <Empty isMobile={isMobile} />
            )}
        </>
    );
}
